export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            欢迎提供线索、投稿或商务合作咨询
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</div>
                  <div className="text-xs text-foreground-600">tougao@51heiliao.com</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</div>
                  <div className="text-xs text-foreground-600">51黑料吃瓜</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 mb-1">客服咨询</div>
                  <div className="text-xs text-foreground-600">service@51heiliao.com</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-briefcase-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 mb-1">商务合作</div>
                  <div className="text-xs text-foreground-600">biz@51heiliao.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}